module.exports = __webpack_public_path__ + "img/9.59be67e1.png";